import React, { useMemo, useState } from "react";

import PropTypes from "prop-types";

const ManageTimeOffContext = React.createContext();

export const ManageTimeOffContextProvider = (props) => {
    const [upcomingPendingTimeOffRequestCount, setUpcomingPendingTimeOffRequestCount] = useState(0);
    const [rejectActionFromMenu, setRejectActionFromMenu] = useState(false);
    const [isManageViewRequest, setIsManageViewRequest] = useState(false);
    const [manageTimeOffRequestsData, setManageTimeOffRequestsData] = useState([]);
    const [areTimeOffRequestsLoading, setAreTimeOffRequestsLoading] = useState(true);
    const [areTimeOffRequestsRefetching, setAreTimeOffRequestsRefetching] = useState(true);

    const contextValue = useMemo(() => {
        return {
            upcomingPendingTimeOffRequestCount,
            setUpcomingPendingTimeOffRequestCount,
            rejectActionFromMenu,
            setRejectActionFromMenu,
            isManageViewRequest,
            setIsManageViewRequest,
            manageTimeOffRequestsData,
            setManageTimeOffRequestsData,
            areTimeOffRequestsLoading,
            setAreTimeOffRequestsLoading,
            areTimeOffRequestsRefetching,
            setAreTimeOffRequestsRefetching,
        };
    }, [
        upcomingPendingTimeOffRequestCount,
        setUpcomingPendingTimeOffRequestCount,
        rejectActionFromMenu,
        setRejectActionFromMenu,
        isManageViewRequest,
        setIsManageViewRequest,
        manageTimeOffRequestsData,
        setManageTimeOffRequestsData,
        areTimeOffRequestsLoading,
        setAreTimeOffRequestsLoading,
        areTimeOffRequestsRefetching,
        setAreTimeOffRequestsRefetching,
    ]);

    return (
        <ManageTimeOffContext.Provider value={contextValue}>
            {props.children}
        </ManageTimeOffContext.Provider>
    );
};

ManageTimeOffContextProvider.propTypes = {
    children: PropTypes.node,
};

export default ManageTimeOffContext;
